import { forwardRef } from 'react'

import styles from './DragImage.module.css'

const DragImage = forwardRef<
	HTMLDivElement,
	React.HTMLAttributes<HTMLDivElement>
>((props, ref) => {
	return <div className={styles.dragImage} {...props} ref={ref} />
})

DragImage.displayName = 'DragImage'

export default DragImage
